import React, { ChangeEvent, useState } from 'react';

import normalizeAccessCode, {
  ACCESS_CODE_LENGTH,
} from 'screens/WallBoardSetUp/normalizeAccessCode';

import AccessCodeBoxes from './AccessCodeBoxes';
import { OverlayInput } from './styles';

/**
 * A wallboard access code entry: 5 boxes that fill as it's typed, in capitals.
 * One real input lies over the boxes (not one per box), so typing, pasting,
 * deleting and TV remote keyboards all work as in a normal field.
 * onComplete fires as the 5th character arrives.
 */
const AccessCodeInput = ({
  value,
  onChange,
  onComplete,
  testId,
}: {
  value: string;
  onChange: (code: string) => void;
  onComplete: (code: string) => void;
  testId?: string;
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const code = normalizeAccessCode(event.target.value);
    onChange(code);
    if (
      code.length === ACCESS_CODE_LENGTH &&
      value.length < ACCESS_CODE_LENGTH
    ) {
      onComplete(code);
    }
  };

  return (
    <AccessCodeBoxes
      code={value}
      activeIndex={
        isFocused && value.length < ACCESS_CODE_LENGTH
          ? value.length
          : undefined
      }
    >
      <OverlayInput
        value={value}
        onChange={onInputChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-label="Access code"
        autoCapitalize="characters"
        autoCorrect="off"
        autoComplete="off"
        spellCheck={false}
        data-testid={testId}
      />
    </AccessCodeBoxes>
  );
};

export default AccessCodeInput;
